var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.residences
    ? _c(
        "section",
        [
          _vm.residences.length > 0
            ? _c(
                "div",
                {
                  staticClass: "c-residence-list",
                  class: {
                    "c-residence-list--cards": _vm.listType === "cards"
                  },
                  attrs: { id: "residenceList" }
                },
                _vm._l(_vm.residences, function(residence, index) {
                  return _c("residence-item", {
                    key: residence.id,
                    attrs: { id: residence.id, index: index }
                  })
                }),
                1
              )
            : _c("residence-list-empty")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }